require('../../asset/style/style.scss');
require('../dish-menu/application.scss');
require('./application.scss');
require('../../component/dish-menu/cart/cart.scss');

const React = require('react');
const connect = require('react-redux').connect;
const actions = require('../../action/dish-menu/dish-menu-zc');
const findDOMNode = require('react-dom').findDOMNode;
const config = require('../../config.js');
import Immutable from 'seamless-immutable';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import commonActions from '../../action/common-action/common-action';
import { bindActionCreators } from 'redux';
import { getTableInfoInSessionStorage, overWriteSessionStorage } from '../../helper/order-dinner-cart-helper';
import PreloadSkeleton from '../../component/dish-menu/preload-skeleton';
import DishCouponSuccess from '../../component/dish-menu/dish-coupon-success.jsx';
import HttpsProtocolImage from '../../component/common/https-protocol-image';
const Loading = require('../../component/mui/loading.jsx');
const DishTypeScroller = require('../../component/dish-menu/dish-type-scroller.jsx');
const DishScroller = require('../../component/dish-menu/dish-scroller.jsx');
const DishGuid = require('../../component/dish-menu/dish-guid.jsx');
import DishDetailContainer from '../../component/dish-menu/detail/dish-detail-container.jsx';
const DishDescPopup = require('../../component/dish-menu/detail/dish-desc-popup.jsx');
const QuickMenu = require('../../component/dish-menu/cart/quick-menu.jsx');
const SearchDish = require('../../component/dish-menu/search-dish.jsx');
const MessageDialog = require('../../component/mui/dialog/message-dialog.jsx');
const DishMesthead = require('../../component/dish-menu/dish-mesthead.jsx');
const Toast = require('../../component/mui/toast.jsx');
const SyncOrderToast = require('../../component/mui/sync-order-toast.jsx');
const BtnShortcutMulti = require('../../component/common/btn-shortcut-multi.jsx');
const helper = require('../../helper/dish-helper');
const secondsToPayhelper = require('../../helper/seconds-to-pay');
const isKoubei = secondsToPayhelper.getSecondsToPayParams().isKoubei; // 是否是口碑
const shopId = helper.getUrlParam('shopId');
const type = helper.getUrlParam('type');
let dishIdFromUrl = helper.getUrlParam('dishId');
const isFromTsButton = helper.getUrlParam('fromTsButton') === 'true';
const addDishStatus = helper.getUrlParam('addDishes');
const classnames = require('classnames');
const dishCart4DinnerUrl = `${config.dishCart4DinnerURL}?type=${type}&shopId=${shopId}`;
const dishCart4DinnerUrlPayFirst = `${config.dishCart4DinnerPayFirst}?type=${type}&shopId=${shopId}`;
const includeAlipayJSApi = require('../../helper/common-helper.js').includeAlipayJSApi;
const isAlipayMiniProgramBrowser = require('../../helper/common-helper.js').isAlipayMiniProgramBrowser;
const doClearSocketShoppingCart = require('../../helper/order-dinner-cart-helper').doClearSocketShoppingCart;
const DinnerSocketHelper = require('../../helper/socket-helper');
const callWxClientMethod = require('../../helper/wx-client-helper.js').callWxClientMethod;
const commonHelper = require('../../helper/common-helper');
import defaultPic from '../../asset/images/head-default-new.svg';
import shopCloseImg from '../../asset/images/yidayang.svg';
import ordertogether from '../../asset/images/order-together/ordertogether.png';
import joinword from '../../asset/images/order-together/joinword.svg';
import combinedword from '../../asset/images/order-together/combinedword.svg';
const isWeiXinBrowser = commonHelper.getWeixinVersionInfo().weixin; // 判断是否微信浏览器
const isAlipayBrowser = commonHelper.isAlipayBrowser(); // 判断是否支付宝浏览器
const isWeiXinMiniBrowser = commonHelper.isWechatMiniProgramBrowser();
import DishHotSlide from '../../component/dish-menu/dish-hot-slide';
import ReceiveCoupons from '../../component/common/receive-coupons';
import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import dishMenuMessages from '../../intl/messages/dish-menu';
import errorMessages from './../../intl/messages/error-message';
import globalMessages from './../../intl/messages/global';
import buttonMessages from '../../intl/messages/button';
import shopMessages from '../../intl/messages/shop';
import containnerText1 from '../../intl/messages/container/part1';
import FullscreenAd from '../../component/fullscreen-ad';
import cartMessages from './../../intl/messages/shopping-cart';
import { initWXShareEventWithConfig } from '../../helper/wx-share-config.js';
import { WxSharEventEntry, DishPropertyTypes, SYNC_CART_UNAVAILABLE, RECONNECTION_ATTEMPTS } from '../../helper/const.js';
import pageHelper from '../../helper/page-helper';
import aliminiProgramHelper from '../../helper/ali-miniprogram-helper';
import { getPrepaidCodes } from '../../helper/prepaid-code';
import ccbAppHelper from '../../helper/Ccb-app-helper';
import HealthIcon from '../../component/health-icon';
import SelfChooseMustOrder from '../../component/dish-menu/self-choose-must-order';

const DishMenuZcApplication = React.createClass({
  displayName: 'DishMenuZcApplication',
  propTypes: {
    // MapedActionsToProps
    fetchMenuData: React.PropTypes.func.isRequired,
    fetchSoldDishList: React.PropTypes.func.isRequired,
    fetchTableInfo: React.PropTypes.func.isRequired,
    activeDishType: React.PropTypes.func.isRequired,
    orderDish: React.PropTypes.func.isRequired,
    toggleDishDetailPopup: React.PropTypes.func.isRequired,
    toggleDishDescPopup: React.PropTypes.func.isRequired,
    fetchOrderDiscountInfo: React.PropTypes.func.isRequired,
    fetchDishMarketInfos: React.PropTypes.func.isRequired,
    clearErrorMsg: React.PropTypes.func.isRequired,
    showErrMsgFunc: React.PropTypes.func.isRequired,
    getMarketCoupons: React.PropTypes.func.isRequired,
    fetchUserInfo: React.PropTypes.func.isRequired,
    fetchWXAuthInfo: React.PropTypes.func.isRequired,
    closeInfoWindow: React.PropTypes.func.isRequired,
    fetchTableIdFromNewVersionQRCode: React.PropTypes.func,
    syncShoppingCart: React.PropTypes.func.isRequired,
    addOrderNotice: React.PropTypes.func.isRequired,
    readOrderNotice: React.PropTypes.func.isRequired,
    removeAllOrders: React.PropTypes.func.isRequired,
    reinstateUndefined: React.PropTypes.func.isRequired,
    setToastProps: React.PropTypes.func.isRequired,
    saveTableInfoFromUrl: React.PropTypes.func,
    errorMessage: React.PropTypes.string,
    fetchServiceStatusNoTable: React.PropTypes.func.isRequired,
    cancelCallMsg: React.PropTypes.func.isRequired,
    updateCanCall: React.PropTypes.func,
    fetchShopInfo: React.PropTypes.func,
    setPageLoadedStatus: React.PropTypes.func,
    dataInitIsOver: React.PropTypes.func,
    setErrorMsg: React.PropTypes.func,
    // MapedStatesToProps
    dishDescData: React.PropTypes.object,
    dishMenuZcReducer: React.PropTypes.object.isRequired,
    dishMenuReducer: React.PropTypes.object.isRequired,
    callBell: React.PropTypes.func.isRequired,
    clearBell: React.PropTypes.func.isRequired,
    // fetchTableId: React.PropTypes.func.isRequired,
    dishesDataDuplicate: React.PropTypes.array,
    dishDetailData: React.PropTypes.object,
    openTimeList: React.PropTypes.array,
    normalDiscountProps: React.PropTypes.object,
    dishPageTpl: React.PropTypes.string,
    getCoupontoGuid: React.PropTypes.func,
    guidStatus: React.PropTypes.bool,
    // saveTableParam
    saveTableParam: React.PropTypes.func.isRequired,
    userOrderedDishList: React.PropTypes.object,
    common: React.PropTypes.object,
    shopMinConsume: React.PropTypes.object,
    getMinConsumeConf: React.PropTypes.func,
  },
  childContextTypes: {
    brandType: React.PropTypes.string,
  },
  getChildContext() {
    const { common = {} } = this.props;
    const { brandInfo = {} } = common;
    return { brandType: brandInfo.brandType };
  },
  getDefaultProps() {
    return {
      dishMenuReducer: {
        dishPageTpl: 'default',
        allDiscount: null, // 设置弹出层
      },
    };
  },
  getInitialState() {
    return {
      isMinMesthead: false,
      isChildrenShow: false,
      animationBottom: 0,
      animationItem: [],
      loadingInfo: null,
      isShowSearch: false,
      showDishCouponSuccess: true,
      showFixedCoupon: true, // 默认领券弹出层
      showHotSpan: false,
      showCouponList: false,
      isSync: false, // 是否是协同点餐
      isShowAlreadyGotCoupon: false,
      dishIdForStatistics: dishIdFromUrl, // 埋点统计是否为推荐菜进入商品详情页
      isShowOpenStatus: true, // 是否展示已打烊对话框
      autoAddedMustOrderDishes: null,
      showSelfChoose: false,
      isShowLoginExceptionDialog: false, // 建行登录异常模态框显示与否
      showLoginExceptionDesc: '登录异常，不可点餐', // 建行登录异常模态框显示与否
    };
  },
  flyQueue: [],
  flyFree: true,
  syncCartUnavailable: false, // 协同购物车不可用
  componentWillMount() {
    // 每次进入页面清除协同购物车不可用标识
    window.sessionStorage && window.sessionStorage.removeItem(SYNC_CART_UNAVAILABLE);
    this.canSlip = true;
    this.canFoldup = false;
    this.scrollTimeout = null;
    this.getShoppingCartInterval = null;
    const { toggleDishDescPopup, setErrorMsg } = this.props;
    commonHelper.getCommericalInfo(setErrorMsg, (commericalInfo = {}) => {
      if (!commericalInfo.enablePortalStore) {
        setErrorMsg({
          text: formatMessage(errorMessages.notMobileStore),
          timeout: -1,
        });
      }
    });

    if (isKoubei) {
      // 口碑保存在 sessionStorage 里面, 不是口碑就不保存
      sessionStorage.isKoubei = true;
    }

    if (isAlipayBrowser) {
      includeAlipayJSApi(() => {});
    }

    window.addEventListener('hashchange', () => {
      const hash = location.hash;
      if (hash === '') {
        this.setHotViewAccordingToHash();
        toggleDishDescPopup();
      }

      if (hash && hash !== '#hot-dish' && hash !== '#dish-desc') {
        this.setHotViewAccordingToHash();
      }

      if (hash && hash !== '#dish-desc' && hash === '#hot-dish') {
        toggleDishDescPopup();
      }
    });

    this._cache = {};
  },
  componentDidMount() {
    sessionStorage.removeItem('tagsType');
    const {
      fetchMenuData,
      fetchSoldDishList,
      fetchOrderDiscountInfo,
      fetchDishMarketInfos,
      saveTableInfoFromUrl,
      fetchUserInfo,
      fetchTableInfo,
      fetchShopInfo,
      setPageLoadedStatus,
      dataInitIsOver,
      fetchMustOrderMenu,
      getMinConsumeConf,
    } = this.props;

    // 获取未支付订单信息
    const tableInfo = getTableInfoInSessionStorage(shopId);
    const tableId = helper.getUrlParam('tableId') || tableInfo.tableId;
    const tableKey = helper.getUrlParam('tableKey') || tableInfo.tableKey;
    const orderId = helper.getUrlParam('orderId');
    const ownerId = helper.getUrlParam('ownerId') || tableInfo.ownerId;
    const addDishes = helper.getUrlParam('addDishes');
    const isPayFirst = sessionStorage.getItem('diningForm') === '2';
    const isScanCodeFromPage = sessionStorage.getItem('isScanCodeFromConf') === 'true'; // 如果是客户配置了url参数为&scan=true
    // 判断是否是扫码点餐 如果是扫码点餐需要在本地写入localStorage
    if ((tableId || tableKey || isScanCodeFromPage) && !addDishes) {
      sessionStorage.isScanCode = true;
    }

    const saveTableInfo = () => {
      return saveTableInfoFromUrl({ tableId, tableKey, orderId, ownerId }).then(res => {
        if (!res || typeof res !== 'object') {
          return;
        }
        const { serviceStatus = {}, ifJumpToDishMenu } = res;
        if (ifJumpToDishMenu) {
          throw new Error('跳转阻塞');
        }
        const isOneTableOneBill = serviceStatus.tableWay === 'oneTableOneBill';

        if (serviceStatus.tableId || serviceStatus.orderId) {
          this.setLoadingInfo({
            ing: true,
            text: formatMessage(errorMessages.connectingCollCart),
          });
        }
        if (isOneTableOneBill) {
          overWriteSessionStorage(shopId, {
            tableId: serviceStatus.tableId,
            tableKey: serviceStatus.tableKey,
            orderId: serviceStatus.orderId,
          });
        } else {
          overWriteSessionStorage(shopId, {
            tableId: serviceStatus.tableId,
            tableKey: serviceStatus.tableKey,
          });
        }

        // 订单未确认状态下进行操作（一桌一单有orderId的情况下）
        // 正餐先付不跳转
        if (sessionStorage.getItem('jupmOrder') !== 'uncheckOrder' && !isPayFirst) {
          if (serviceStatus.orderId && serviceStatus.orderId > 0 && !addDishes && isOneTableOneBill) {
            // 标识跳转到订单未结算页面
            sessionStorage.setItem('jupmOrder', 'dishMenu');
            location.href = `${config.tradeDetailUncheckURL}?orderId=${serviceStatus.orderId}&type=${type}&shopId=${shopId}`;
            throw new Error('跳转阻塞');
          }
        }
        const tableInfoFromSession = getTableInfoInSessionStorage(shopId);
        const tableIdFromSession = tableInfoFromSession.tableId;
        const tableKeyFromSession = tableInfoFromSession.tableKey;

        fetchUserInfo(serviceStatus.memberVO);

        if (addDishStatus) {
          // 在加菜模式下不会刷新 scanTableType
          return;
        }
        /* 因为操作中会刷新页面 所以不能清除 scanTableType && oriScanTableType */
        if (!sessionStorage.oriScanTableType) {
          sessionStorage.removeItem('scanTableType');
        }

        if (tableIdFromSession || tableKeyFromSession) {
          fetchTableInfo(tableInfoFromSession);
          /* 新的 scanTableType = 1 老的 scanTableType = 2 */
          if (tableIdFromSession) {
            sessionStorage.scanTableType = sessionStorage.oriScanTableType || 2;
          } else if (tableKeyFromSession) {
            sessionStorage.scanTableType = 1;
          }
        }
      });
    };

    // 建行App环境下，无感登录逻辑
    this.outComeInAndLoginLogic();

    Promise.all([fetchShopInfo(tableId, tableKey), getMinConsumeConf()])
      .then(fetchMenuData)
      .then(fetchMustOrderMenu)
      .then(fetchSoldDishList)
      .then(saveTableInfo)
      .then(() => {
        setPageLoadedStatus(true);
      })
      .then(fetchDishMarketInfos)
      .then(discountRule => fetchOrderDiscountInfo(discountRule))
      .then(() => {
        const { serviceStatus = {}, userInfo } = this.props.dishMenuZcReducer;
        const { enableSyncShoppingCart, shopInfo = {} } = this.props.dishMenuReducer; // 是否开启了协同购物车
        const { tableId: curTableId, orderId: curOrderId } = serviceStatus;

        this.setState({ isSync: !!(curTableId || curOrderId) });
        if ((curTableId || curOrderId) && userInfo && enableSyncShoppingCart !== 0) {
          this.getShoppingCartInterval = setInterval(() => {
            if (this.syncCartUnavailable) {
              clearInterval(this.getShoppingCartInterval);
              this.initDishList();
            } else if (this._dinnerSocket && this._dinnerSocket.socket.connected) {
              this.props.removeAllOrders(); // 连上协同购物车再清除本地点过的菜记录
              this._dinnerSocket.getShoppingCartEventInCart(
                (userOrderedDishList, shoppingCartResult) => {
                  this.setLoadingInfo(null);
                  setTimeout(() => {
                    this.syncShoppingCart({ userOrderedDishList, userInfo: this._userInfo }, () => {
                      dataInitIsOver(true);
                      this.mustOrderDishInit();
                      this.syncLocalStorageDishes();
                    });
                  }, 200);
                },
                () => {
                  this.setLoadingInfo({
                    ing: true,
                    text: formatMessage(errorMessages.connecting),
                  });
                },
              );
              clearInterval(this.getShoppingCartInterval);
            }
          }, 1500);
        } else {
          this.initDishList();
        }

        // this.scrollTimeout = setTimeout(() => {
        //   this.scrollToTop();
        // }, 1000);

        if (
          (!shopInfo.isOldMarketing && shopInfo.couponList && shopInfo.couponList.length > 0) || // 新逻辑
          (shopInfo.isOldMarketing && shopInfo.marketCoupon && shopInfo.marketCoupon.coupId) // 旧逻辑
        ) {
          this.setState({ showCouponList: true });
        }
      })
      .catch(err => {
        console.log(err.message);
      });

    if (this.props.fetchBrandInfo) {
      this.props.fetchBrandInfo();
    }
  },
  componentWillReceiveProps(nextProps) {
    const { serviceStatus = {}, userInfo } = this.props.dishMenuZcReducer;
    const { userInfo: newUserInfo } = nextProps.dishMenuZcReducer;
    const { load, loadShopStatus, enableSyncShoppingCart } = this.props.dishMenuReducer;
    const { load: loadNew, loadShopStatus: loadShopStatusNew, dishesDataDuplicate } = nextProps.dishMenuReducer;
    const { removeAllOrders } = this.props;

    if (load !== loadNew) {
      this.setLoadingInfo({ ing: loadNew.status, text: loadNew.text });
    }

    if (dishIdFromUrl && dishesDataDuplicate && dishesDataDuplicate.length) {
      const dishData = dishesDataDuplicate.find(item => item.id === dishIdFromUrl);
      if (dishData) {
        location.hash = '#dish-desc';
        this.props.toggleDishDescPopup(dishData);
        dishIdFromUrl = -1;
      }
    }

    if (userInfo !== newUserInfo && (serviceStatus.tableId || serviceStatus.orderId)) {
      const tableInfo = getTableInfoInSessionStorage(shopId);
      const curTableId = serviceStatus.tableId;
      const curOrderId = serviceStatus.orderId;
      const curOwnerId = tableInfo.ownerId;
      if ((curTableId || curOrderId) && enableSyncShoppingCart !== 0) {
        this.dishesLocalStorage =
          helper.getDishesLocalStorage({
            shopId,
            type: helper.getUrlParam('type'),
          }) || {};
        // 清除本地点过的菜记录
        // removeAllOrders();
        this.initDinnerSocketHelper(newUserInfo, curTableId, curOrderId, curOwnerId);
        return;
      }
    }

    if (loadShopStatus !== loadShopStatusNew && loadShopStatusNew) {
      // 表示已经请求了orderPageInfo接口
      const { orderPageTitle } = nextProps.dishMenuReducer;
      document.title = orderPageTitle || formatMessage(globalMessages.mealOrder);
      this.title = document.title;
    }
  },
  componentDidUpdate() {
    const el = findDOMNode(this);

    initWXShareEventWithConfig({ entry: WxSharEventEntry.SHOP, _this: this });

    if (this._cache.mesthead) {
      return;
    }

    this._cache = {
      mesthead: el.querySelector('.dish-mesthead'),
      scrollerWrap: el.querySelector('.scroller-wrap'),
      shortcutOperator: el.querySelector('.shortcut-operate'),
      lastSourceTapRect: null,
    };
  },
  initDishList() {
    const { dataInitIsOver } = this.props;

    this.setLoadingInfo(null);
    dataInitIsOver(true);
    this.mustOrderDishInit();
  },
  // 同步之前存在localStorage中的菜列表
  syncLocalStorageDishes() {
    const { dishes = [] } = this.dishesLocalStorage || {};
    if (!dishes.length) {
      return;
    }

    const orderedDishes = helper.divideOrderedDishes(dishes);
    orderedDishes.forEach(dishData => {
      const increment = helper.getDishesCount([dishData]);
      this._dinnerSocket.addOrMinusDishEvent(dishData, increment);
    });

    this.dishesLocalStorage = {};
    helper.clearDishesLocalStorage();
  },
  outComeInAndLoginLogic() {
    const isCcbEvn = ccbAppHelper.isCcbEvn();
    if (!isCcbEvn) return Promise.resolve();

    const ccbParamSJ = helper.getUrlParam('ccbParamSJ'); // 建行传入参数
    const errMsg = formatMessage(globalMessages.urlLostInfo);
    ccbAppHelper
      .getUserIndividual({ shopId, ccbParamSJ, errMsg })
      .then()
      .catch(ex => {
        if (typeof ex === 'string') {
          this.setState({ showLoginExceptionDesc: ex });
        }
        this.setState({ isShowLoginExceptionDialog: true });
      });

    // return fetch(`${config.individualAPI}?shopId=${shopId}`, config.requestOptions)
    //   .then((res = {}) => {
    //     console.log('---res', res);
    //     if (!res.ok) {
    //       if (!ccbParamSJ) {
    //         throw formatMessage(globalMessages.urlLostInfo);
    //       }
    //       return ccbAppHelper
    //         .getUserInfo(ccbParamSJ)
    //         .then(userInfo => {
    //           return ccbAppHelper.login({ shopId, mobile: userInfo.mobile || '' });
    //         })
    //         .catch(ex => {
    //           throw ex;
    //         });
    //     }
    //   })
    //   .catch(ex => {
    //     console.error(ex);
    //     if (typeof ex === 'string') {
    //       this.setState({ showLoginExceptionDesc: ex });
    //     }
    //     this.setState({ isShowLoginExceptionDialog: true });
    //   });
  },
  getNeedAutoAddDishes() {
    const { serviceStatus, userOrderedDishList, mustOrderDishList } = this.props.dishMenuZcReducer;
    const { shopInfo = {}, dishesDataDuplicate } = this.props.dishMenuReducer;
    const { tableId: curTableId, orderId: curOrderId } = serviceStatus;
    // 未连上协同购物前点的菜列表
    const { dishes: localDishes = [] } = this.dishesLocalStorage || {};

    // 开启必点菜 & 有桌台ID & 么有订单号 才返回需自动加入的必点菜列表
    if (shopInfo.enableOpenDish && curTableId && !curOrderId) {
      const orderedDishes = this.getCurrentOrderedDishes(userOrderedDishList, dishesDataDuplicate).concat(localDishes);
      const orderedDishesIdMap = orderedDishes.reduce((t, c) => {
        t[c.brandDishId] = 1;
        return t;
      }, {});
      const needAutoAddDishes = mustOrderDishList.filter((item = {}) => !orderedDishesIdMap[item.brandDishId]);

      return needAutoAddDishes;
    }

    return [];
  },
  mustOrderDishInit() {
    const { selfChooseDishList, serviceStatus } = this.props.dishMenuZcReducer;
    const { shopInfo = {} } = this.props.dishMenuReducer;
    const { tableId: curTableId, orderId: curOrderId, peopleCount } = serviceStatus;
    const needAutoAddDishes = this.getNeedAutoAddDishes();

    // 必点菜需要人数
    if (needAutoAddDishes.length && !peopleCount) {
      location.href = `${config.dishMenu4DinnerChoosePeopleURL}?shopId=${shopId}&tableId=${curTableId}&returnUrl=${encodeURIComponent(location.href)}`;
      return;
    }

    // 开启开台必点&有桌台号&没有订单号&有开台自选菜
    if (shopInfo.enableOpenDish && curTableId && !curOrderId && selfChooseDishList.length) {
      this.setState({ showSelfChoose: true });
    } else if (needAutoAddDishes.length) {
      this.autoAddMustOrderDishes(needAutoAddDishes);
    }
  },
  handleConfirmSelfChoose() {
    const needAutoAddDishes = this.getNeedAutoAddDishes();

    this.setState({ showSelfChoose: false });
    if (needAutoAddDishes.length) {
      this.autoAddMustOrderDishes(needAutoAddDishes);
    }
  },
  autoAddMustOrderDishes(needAutoAddDishes) {
    const { serviceStatus = {} } = this.props.dishMenuZcReducer;
    const { peopleCount } = serviceStatus;
    const addRecords = [];

    needAutoAddDishes.forEach(item => {
      const { strategyType, strategyValue, dishIncreaseUnit, stepNum, clearStatus } = item;
      const isNormalDish = stepNum === 1;
      // 1 为按桌台，2为按人数
      const count =
        strategyType === 1
          ? Math.max(strategyValue, dishIncreaseUnit)
          : strategyType === 2
          ? isNormalDish
            ? Math.max(strategyValue * peopleCount, dishIncreaseUnit)
            : dishIncreaseUnit
          : 0;
      // 必点且未估清
      if (!count || clearStatus) {
        return;
      }
      const dish = item.asMutable({ deep: true });
      // 必点菜没有套餐
      // 初始化选中的数量以及属性
      // 属性默认选第一个
      if (helper.isSingleDishWithoutProps(dish)) {
        dish.order = count;
      } else {
        dish.order = [
          {
            count,
            dishPropertyTypeInfos: dish.dishPropertyTypeInfos,
            dishIngredientInfos: dish.dishIngredientInfos,
          },
        ];

        if (dish.dishIngredientInfos.length) {
          dish.order[0].dishIngredientInfos[0].isChecked = true;
        }

        if (dish.dishPropertyTypeInfos.length) {
          dish.order[0].dishPropertyTypeInfos.forEach(typeInfo => {
            // 是否有默认做法
            const hasDefaultChecked = typeInfo.properties.find(prop => prop.isChecked);
            if (typeInfo.type === DishPropertyTypes.REMARK || typeInfo.type === DishPropertyTypes.CUSTOMLABEL || hasDefaultChecked) {
              return;
            }

            typeInfo.properties[0].isChecked = true;
          });
        }
      }

      addRecords.push({
        name: dish.name,
        count,
        unitName: dish.unitName,
        brandDishId: dish.brandDishId,
      });

      this.handleOrderDishChange(Immutable.from(dish), count);
    });

    // 添加后显示提示，直到下次加菜
    if (addRecords.length > 0) {
      this.setState({
        autoAddedMustOrderDishes: addRecords,
      });
    }
  },
  onDishDetailAddBtnTap(dishData, dishCount) {
    const { toggleDishDetailPopup } = this.props;
    const { lastSourceTapRect } = this._cache;
    toggleDishDetailPopup();
    if (lastSourceTapRect) {
      this.setState({ dropInShoping: false }, () => {
        this.startBallFlyQueue(lastSourceTapRect);
      });
    }
    this.handleOrderDishChange(dishData, dishCount);
  },
  onShoppingCartRelativeBtnClick() {
    const { shopInfo = {} } = this.props.dishMenuReducer;
    const noBuyWeixinMini = !shopInfo.enableWeixinMini && !!isWeiXinMiniBrowser;
    if (noBuyWeixinMini) return false;
    const status = this.getLoginStatus();
    if (!status.isLogin && status.isSync) {
      this.showLoginPopup();
      return false;
    }

    return true;
  },
  onDishTouchTap(event) {
    const status = this.getLoginStatus();
    if (!status.isLogin && status.isSync) {
      return;
    }

    const { target } = event;
    if (target.parentNode.className === 'counter') {
      this._cache.lastSourceTapRect = target.getBoundingClientRect();
      return;
    }

    if (target.className.indexOf('counter-click-mask') === -1 || target.parentNode.className.indexOf('counter-add') === -1) {
      return;
    }

    const rect = target.getBoundingClientRect();
    this.setState({ dropInShoping: false }, () => {
      setTimeout(() => {
        this.startBallFlyQueue(rect);
      }, 0);
    });
  },
  getCurrentOrderedDishes(userOrderedDishList, dishesDataDuplicate) {
    if (!userOrderedDishList || !userOrderedDishList.length) {
      return helper.getOrderedDishes(dishesDataDuplicate);
    }

    const orderedDishes = [];
    userOrderedDishList.forEach(item => {
      [].push.apply(orderedDishes, item.dishList);
    });
    return orderedDishes;
  },
  setScrollTop(scrollTop) {
    const dishScrollerMain = document.querySelector('.dish-scroller-main');
    if (!dishScrollerMain) {
      return;
    }

    if (scrollTop < 0 && this.canSlip) {
      this.canSlip = false;
      this.canFoldup = true;

      this.methodAfterSlip();
      if (dishScrollerMain.scrollTop <= 0) {
        dishScrollerMain.scrollTop = 1;
      }
    } else if (scrollTop >= 0 && this.canFoldup) {
      this.canFoldup = false;
      this.canSlip = true;

      this.methodAfterFoldUp();
    }
  },

  // scrollToTop() {
  //   this.setScrollTop(-1);
  // },
  getBtnDisable(serviceStatus) {
    const btnDisableArray = [];
    if (!serviceStatus.enablePay) {
      btnDisableArray.push(3);
    }

    if (!serviceStatus.enableOrder) {
      btnDisableArray.push(4);
    }
    return btnDisableArray;
  },
  getLoginStatus() {
    const { userInfo } = this.props.dishMenuZcReducer;
    const { isSync } = this.state;

    return {
      isLogin: !!userInfo,
      isSync,
    };
  },
  setTrunToDetailPage(serviceStatus = {}) {
    if (!serviceStatus.enableTableMultiUse && serviceStatus.enableAddDish && !sessionStorage.getItem('isFirstDish') && serviceStatus.enableOrder) {
      location.href = `${config.tradeDetailUncheckURL}?shopId=${shopId}&orderId=${serviceStatus.orderId}`;
      sessionStorage.setItem('isFirstDish', true);
    }
  },
  getDishTypeInfo(dishTypeId) {
    const { dishTypesData = [] } = this.props.dishMenuReducer;

    for (let i = 0, len = dishTypesData.length; i < len; i++) {
      const cur = dishTypesData[i];
      if (cur.id === dishTypeId) {
        return Object.assign({ order: i }, cur);
      }
    }

    return null;
  },
  setLoadingInfo(info) {
    this.setState({ loadingInfo: info });
  },
  getSameRuleDishList(dish, dishList) {
    const { sameDishIndexs = [] } = dish;
    return sameDishIndexs.map(dishIndex => dishList[dishIndex]);
  },
  setSearchPage(isShowSearch) {
    if (isShowSearch) {
      document.title = formatMessage(globalMessages.search);
    } else {
      document.title = this.title;
    }
    this.setState({ isShowSearch });
  },
  setAllDiscount(allDiscount) {
    this.setState({ allDiscount });
  },
  startBallFlyQueue(start) {
    const { common } = this.props;
    if (common && common.brandInfo && common.brandInfo.brandId === '77299') {
      this.setState({ dropInShoping: true });
      return;
    }
    if (start) {
      const length = this.flyQueue.length;
      if (length < 1) {
        this.flyQueue.push(start);
      }
      // else if (length === 2) {
      //   this.flyQueue[1] = start;
      // }
    }
    // this.ballFlyOutQueue();
  },
  ballFlyOutQueue() {
    if (this.flyFree && this.flyQueue.length > 0) {
      this.flyFree = false;
      this.startBallFly(this.flyQueue.shift());
    }
  },
  startBallFly(start) {
    this.setState({ dropInShoping: false });
    const bottom = this._cache.shortcutOperator.offsetTop + 30;
    helper.ballFlyWhenOrderDish({
      speed: 2.8,
      start: {
        left: start.left - 10,
        top: start.top - 10,
      },
      end: {
        left: window.innerWidth / 2,
        top: bottom,
      },
      className: 'ball',
      onEnd: () => {
        this.flyFree = true;
        this.setState({ dropInShoping: true });
        this.ballFlyOutQueue();
      },
    });
  },
  getRealIncrementAndFromUser(dish, increment) {
    // 非单菜的话，点餐页只能加不能减，不需要修正
    if (!helper.isSingleDishWithoutProps(dish)) {
      return {
        increment,
        userInfo: null,
      };
    }

    // 拿到菜品数据，返回正确的变动数量，以及菜品所在的用户信息
    const { userOrderedDishList, userInfo } = this.props.dishMenuZcReducer;
    const { dishesDataDuplicate = [] } = this.props.dishMenuReducer;

    let orderedDish = null;
    let user = null;
    // 协同点餐
    if (userOrderedDishList && userOrderedDishList.length) {
      // 先找自己有没有点这个菜
      const currentUser = userOrderedDishList.find(item => item.userInfo.userId === userInfo.customerId);
      const currentUserOrderedDish = currentUser && currentUser.dishList ? currentUser.dishList.find(item => item.id === dish.id) : null;

      if (currentUserOrderedDish) {
        orderedDish = currentUserOrderedDish;
      } else {
        const userX = userOrderedDishList.find(item =>
          (item.dishList || []).find(itemDish => {
            if (itemDish.id === dish.id) {
              orderedDish = itemDish;
              return true;
            }

            return false;
          }),
        );

        user = userX ? userX.userInfo : null;
      }
    }

    // 没有人点过
    if (!orderedDish) {
      orderedDish = dishesDataDuplicate.filter(item => item.id === dish.id)[0];
    }

    // 仍然没有
    if (!orderedDish) {
      return {
        increment,
        userInfo: null,
      };
    }

    return {
      increment: helper.adjustOrderedDishIncrement(orderedDish, increment),
      userInfo: user,
    };
  },
  // 清除自动添加的必点菜的通知
  clearAutoAddedMustOrderDishes() {
    if (this.state.autoAddedMustOrderDishes) {
      this.setState({
        autoAddedMustOrderDishes: null,
      });
    }
  },
  handleOrderDishChange(dishData, action, needRender = true) {
    if (!this.onShoppingCartRelativeBtnClick()) {
      return;
    }
    const { orderDish } = this.props;
    const afterFlyingBall = () => {
      if (this._dinnerSocket && !this.syncCartUnavailable) {
        const incrementAndFromUser = this.getRealIncrementAndFromUser(dishData, action);
        this._dinnerSocket.addOrMinusDishEvent(dishData, incrementAndFromUser.increment, null, incrementAndFromUser.userInfo);
        return;
      }

      const dishTypeInfo = this.getDishTypeInfo(dishData.dishTypeId);
      let newDishData = dishData;
      if (dishTypeInfo) {
        newDishData = dishData.set('dishTypeName', dishTypeInfo.name);
      }
      orderDish(newDishData, action);

      setTimeout(() => {
        this.ballFlyOutQueue();
      }, 0);
    };

    afterFlyingBall();

    this.clearAutoAddedMustOrderDishes();

    // if (action > 0) {
    //   setTimeout(afterFlyingBall, 300);
    // } else {
    //   afterFlyingBall();
    // }
  },
  hanleMainClick() {
    const { isChildrenShow } = this.state;
    this.setState({ isChildrenShow: !isChildrenShow });
  },
  jumpDetail(evt, num) {
    evt.preventDefault();
    const {
      dishMenuReducer: { shopInfo = {} },
    } = this.props;
    let fromTsButton = '';
    if (isFromTsButton) {
      fromTsButton = '&fromTsButton=true';
    }

    // 正餐先付跳转先付的购物车页面
    location.href = `${shopInfo.diningForm === 2 ? dishCart4DinnerUrlPayFirst : dishCart4DinnerUrl}${fromTsButton}`;
  },
  closeWindow() {
    const { closeInfoWindow } = this.props;
    closeInfoWindow();
  },
  scanCode() {
    if (!isWeiXinBrowser && !isAlipayBrowser) {
      this.props.showErrMsgFunc(formatMessage(errorMessages.weixinBrowserError));
    } else if (isWeiXinBrowser) {
      this.scanCodeWeixin(); // 唤起微信扫码
    } else {
      this.scanCodeAlipay(); // 唤起支付宝扫码
    }
  },
  scanCodeAlipay() {
    const handleScanErr = errorCode => {
      if (errorCode === 10) {
        // this.props.showErrMsgFunc('用户取消');
      } else {
        this.props.showErrMsgFunc(formatMessage(errorMessages.operateFailError));
      }
    };
    if (isAlipayMiniProgramBrowser()) {
      aliminiProgramHelper.postMessage();
      aliminiProgramHelper.onMessage(res => {
        if (!res) {
          handleScanErr();
          return;
        }
        this.handleScanResult(res.code);
      });
    } else {
      const ap = window.ap;
      if (!ap) {
        this.props.showErrMsgFunc(formatMessage(errorMessages.alipayConfigFailError));
        return;
      }
      ap.scan(
        {
          type: 'qr',
        },
        res => {
          if (res.error) {
            handleScanErr(res.error);
          } else if (!res.code) {
            this.props.showErrMsgFunc(formatMessage(errorMessages.getQRCodeFailError));
          } else {
            this.handleScanResult(res.code);
          }
        },
      );
    }
  },
  scanCodeWeixin() {
    const handleScanErr = (err = {}) => {
      this.props.showErrMsgFunc(`${formatMessage(errorMessages.cantScanPlaceOrderError)}: ${err.errMsg}`);
    };

    callWxClientMethod('scanQRCode', {
      needResult: 1,
      scanType: ['qrCode', 'barCode'],
      success: (res = {}) => this.handleScanResult(res.resultStr),
      error: handleScanErr,
    });
  },
  handleScanResult(str) {
    if (!str) {
      this.props.showErrMsgFunc(formatMessage(errorMessages.identifyQRCodeError));
      return;
    }

    const reg = /tableId=(\w+)/i;
    const match = reg.exec(str);
    // 老二维码可以直接取到tableId
    if (match) {
      sessionStorage.oriScanTableType = 2;
      location.href = `${config.dishMenu4DinnerURL}?shopId=${shopId}&tableId=${match[1]}&type=TS`;
      return;
    }

    // 新二维码需要调用后端接口获取tableId
    this.props.fetchTableIdFromNewVersionQRCode(str);
    sessionStorage.oriScanTableType = 1;
    //  扫码之后重刷页面或调用一下getshoppingcart
    this._dinnerSocket.getShoppingCartEventInCart(
      userOrderedDishList => {
        this.syncShoppingCart({
          userOrderedDishList,
          userInfo: this._dinnerSockert.userInfo,
        });
        this.setLoadingInfo(null);
      },
      () => {
        this.setLoadingInfo({
          ing: true,
          text: formatMessage(errorMessages.connecting),
        });
      },
    );
  },
  clearShoppingcart() {
    this.props.syncShoppingCart({});
    this.props.removeAllOrders();
  },
  showLoginPopup() {
    this.props.setToastProps({
      className: 'order-dish-login-msgbox',
      mainMessage: formatMessage(dishMenuMessages.loginBeforeOrder),
      buttonProp: {
        text: formatMessage(globalMessages.goToLogin),
        className: 'o-tc--primary',
      },
      imgProp: 'login',
      onBtnTap: () => {
        pageHelper.navigateToLoginPage({
          shopId,
        });
      },
    });
  },

  initDinnerSocketHelper(userInfo, curTableId, curOrderId, curOwnerId) {
    this.setLoadingInfo({
      ing: true,
    });
    if (!userInfo) {
      return null;
    }
    if (this._dinnerSocket) {
      return this._dinnerSocket;
    }
    const { serviceStatus } = this.props.dishMenuZcReducer;
    const customerId = serviceStatus.memberVO.customerId;
    const isOneTableOneBill = serviceStatus.tableWay === 'oneTableOneBill'; // 一桌一单
    const userNickname = commonHelper.getUserName(userInfo);
    const userPicPath = commonHelper.getUserAvatar(userInfo);
    const _userInfo = (this._userInfo = {
      userId: customerId,
      mobile: userInfo.mobile,
      userPicPath,
      userNickname,
      sex: String(userInfo.sex) === '0' || String(userInfo.sex) === '1' ? userInfo.sex : -1,
      shopId,
      tableId: curTableId,
      orderId: curOrderId,
      ownerId: isOneTableOneBill ? curTableId : curOwnerId || customerId,
    });
    const dinnerSocket = new DinnerSocketHelper({
      reconnectionAttempts: RECONNECTION_ATTEMPTS,
      userInfo: _userInfo,
      tableWay: serviceStatus.tableWay,
      onConnectError: (connectionErrCount) => {
        // this.props.showErrMsgFunc(formatMessage(errorMessages.collCartError));  // 协同购物车错误不提示
        if (connectionErrCount >= RECONNECTION_ATTEMPTS + 1) { // 错误次数超过最大重连次数，设置协同购物车不可用
          this.setLoadingInfo(null);
          window.sessionStorage && window.sessionStorage.setItem(SYNC_CART_UNAVAILABLE, 'true');
          this.syncCartUnavailable = true; // 将协同购物车设置为不可用
        }
      },
      onBeforeAddOrMinusDish: orderDish => {
        const dishTypeInfo = this.getDishTypeInfo(orderDish.dishTypeId);
        if (dishTypeInfo) {
          Object.assign(orderDish, {
            dishTypeName: dishTypeInfo.name,
            dishTypeOrder: dishTypeInfo.order,
          });
        }
        if (!this.NetWorkErrorTimeOut) {
          this.NetWorkErrorTimeOut = setTimeout(() => {
            this.setLoadingInfo({
              text: formatMessage(errorMessages.netWorkError),
            });
          }, 1500);
        }
      },
      onBeforeJoinRoom: () => {
        this.setLoadingInfo({
          ing: true,
          text: formatMessage(errorMessages.intoTableError),
        });
      },
      onBeforeInitDishes: orderedDishes => {
        const { dishesDataDuplicate } = this.props.dishMenuReducer;
        const _orderedDishes = orderedDishes || [];
        const assignDishIngredientInfos = dish => {
          if (!dish.dishIngredientInfos || dish.dishIngredientInfos.length) {
            return;
          }
          const originDish = dishesDataDuplicate.filter(item => item.id === dish.id)[0];
          if (originDish && originDish.dishIngredientInfos && originDish.dishIngredientInfos.length) {
            Object.assign(dish, {
              dishIngredientInfos: [{ id: -1, reprice: 0 }],
            });
          }
        };
        _orderedDishes.forEach(dish => assignDishIngredientInfos(dish));
      },
      onAfterJoinRoom: success => {
        this.setLoadingInfo(null);
      },
      onNetworkDelay: delayMsg => {
        // this.props.setErrorMsg({ text: delayMsg, timeout: 2000 });
        this.setLoadingInfo(null);
        // 断开连接后不提示用户已经断开
        // this.props.setToastProps({
        //   mainMessage: delayMsg || <FormattedMessage {...errorMessages.socketLinkError} />,
        //   buttonProp: { text: <FormattedMessage {...buttonMessages.iknown} /> },
        //   onBtnTap: () => {
        //     window.location.reload();
        //   },
        //   imgProp: userInfo.userPicPath,
        //   userName: userInfo.userNickname,
        // });
      },
    });
    dinnerSocket.dishNoticeListener((result, dishIncreaseUnit, minNum, stepNum) => {
      clearTimeout(this.NetWorkErrorTimeOut);
      this.NetWorkErrorTimeOut = null;
      this.setLoadingInfo(null);
      const [dish] = result.orderData;
      const { userInfo: operatorInfo = {} } = result;
      const { addOrderNotice, readOrderNotice } = this.props;
      const isOther = operatorInfo.userId !== _userInfo.userId;
      const notice = {
        isOther,
        userInfo: operatorInfo,
        orderDishes: result.orderData,
        increment: dish.num,
      };
      const originUserOrderedDishList = this.props.dishMenuZcReducer.userOrderedDishList || [];
      const updateSyncShoppingCart = this.props.dishMenuZcReducer.updateSyncShoppingCart;
      let originMinNumber = 0;
      let minNumber = 0;
      const getMinNumber = (dishList = [], syncShoppingCart = {}) => {
        let number = 0;
        dishList.forEach((item = {}, index) => {
          if (item.dishList && item.dishList.length === 0) {
            return;
          }
          item.dishList.forEach((itemt = {}, indext) => {
            if (
              itemt.brandDishId === result.orderData[0].brandDishId &&
              itemt.id === result.orderData[0].id &&
              /* syncShoppingCart.userInfo.userId === result.userInfo.userId && */
              item.userInfo.userId === result.userInfo.userId
            ) {
              if (typeof itemt.order === 'number') {
                number = itemt.order;
              } else {
                number = itemt.order[0].count;
              }
            }
          });
        });
        return number;
      };
      originMinNumber = getMinNumber(originUserOrderedDishList, updateSyncShoppingCart);
      if (originMinNumber === 0 && minNum < 0) {
        // 阻止请求发送
        return;
      }
      addOrderNotice(notice);
      const userOrderedDishList = this.props.dishMenuZcReducer.userOrderedDishList;
      minNumber = getMinNumber(userOrderedDishList, updateSyncShoppingCart);
      if (minNum < 0) {
        if (userOrderedDishList && userOrderedDishList.length && originUserOrderedDishList && originUserOrderedDishList.length) {
          if (minNumber === 0 && originMinNumber !== 0 && originMinNumber - stepNum < dishIncreaseUnit) {
            // 小于步长
            if (updateSyncShoppingCart) {
              this._dinnerSocket.addOrMinusDishEvent(updateSyncShoppingCart.orderDishes[0], Number(`-${dishIncreaseUnit}`), () => {}, result.userInfo);
            }
          }
        }
      }
      // 其他点菜通知
      if (isOther) {
        setTimeout(() => {
          readOrderNotice();
        }, 2000);
      } else {
        this.props.orderDish(dish, notice.increment, false);
      }
    });
    dinnerSocket.clearShoppingcartListener((result = {}) => {
      const { setToastProps } = this.props;
      this.clearShoppingcart();
      this.clearAutoAddedMustOrderDishes();
      doClearSocketShoppingCart({
        setToastProps,
        userInfo: result,
        tradeDetailUncheckURL: `${config.tradeDetailUncheckURL}?type=TS&shopId=${shopId}&orderId=${result.orderId}&tableId=${result.tableId}`,
      });
    });
    dinnerSocket.errorListener((error = {}) => {
      this.setLoadingInfo(null);
      // 不显示购物车连接断开
      // this.props.showErrMsgFunc(`${formatMessage(errorMessages.collCartError)}： ${error.msg || error}`);
    });
    dinnerSocket.noticePlaceOrder((result = {}) => {
      this.props.showErrMsgFunc(`${result.userNickname}${formatMessage(dishMenuMessages.alreadyOrderedAndRedirecting)}`);
      setTimeout(() => {
        location.href = `${config.tradeDetailUncheckURL}?type=TS&shopId=${shopId}&orderId=${result.orderId}&tableId=${result.tableId}`;
      }, 3000);
    });
    this._dinnerSocket = dinnerSocket;
    return this._dinnerSocket;
  },
  syncShoppingCart(args, callBack) {
    const { syncShoppingCart } = this.props;

    syncShoppingCart(args);

    if (callBack) {
      callBack();
    }
  },
  closeDishCouponSuccess() {
    this.setState({ showDishCouponSuccess: false });
  },
  methodAfterSlip() {
    this.setState({
      flodUpAppendCss: 'flodup',
    });
  },
  methodAfterFoldUp() {
    this.setState({
      flodUpAppendCss: '',
    });
  },
  closeFixedCoupon(evt) {
    new Promise((resolve, reject) => {
      this.props.getCoupontoGuid(true, resolve);
    }).then(() => {
      this.setState({ showFixedCoupon: false });
    });

    if (evt) {
      evt.preventDefault();
    }
  },
  // 热销菜品推荐
  showHotSpans(e) {
    e.preventDefault();
    this.setState({ showHotSpan: true });

    e.preventDefault();
    e.stopPropagation();
    location.hash = '#hot-dish';
  },
  cancelHotSpan(e) {
    this.setState({ showHotSpan: false });

    e.preventDefault();
    e.stopPropagation();
    location.hash = '';
  },
  setHotViewAccordingToHash() {
    this.setState({ showHotSpan: false });
  },
  getDishHotElement(data = [], dish = []) {
    const hotElement = [];
    if (data && dish) {
      data.forEach((temp, index) => {
        // 热销菜品
        dish.forEach((item, i) => {
          // 所有菜品
          if (String(temp.dishId) === String(item.id)) {
            hotElement.push(
              Object.assign({}, item, {
                soldNum: temp.soldNum || item.soldNum,
                index: i,
              }),
            );
          }
        });
      });
    }
    return hotElement;
  },
  getReceiveCouponsStatus(name) {
    const { shopInfo = {} } = this.props.dishMenuReducer;
    let status = true;
    if (helper.getUrlParam('getCoupon')) {
      status = false;
    }

    if (shopInfo.isOldMarketing) {
      // 老逻辑标识已经领过券了
      const { marketCoupon = {} } = shopInfo;
      const { coupId } = marketCoupon;
      const alreadySendCouponOld = localStorage.alreadySendCouponOld || '';
      if (alreadySendCouponOld.indexOf(`${type}_${shopId}_${coupId}`) !== -1) {
        // WM_810005865_82847257400999936
        status = false;
      }
      if (shopInfo.marketCoupon && !shopInfo.marketCoupon.flag && (shopInfo.marketCoupon.type === 2 || shopInfo.marketCoupon.type === 1)) {
        status = false;
      }
    } else {
      // 新逻辑标识领券了
      const { ruleId, planId } = shopInfo;
      const alreadySendCouponNew = localStorage.alreadySendCouponNew || '';
      if (alreadySendCouponNew.indexOf(`${type}_${shopId}_${ruleId}_${planId}`) !== -1) {
        // dishWM_WM_810005865
        status = false;
      }
      if ((!shopInfo.flag && (shopInfo.type === 1 || shopInfo.type === 2)) || shopInfo.couponSuccess) {
        status = false;
      }
    }

    return status;
  },
  hiddenCouponsList(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({ showCouponList: false, isShowAlreadyGotCoupon: false });
  },
  showCouponsList(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({ showCouponList: true });
  },
  showAlreadyGotCoupon(showStatus) {
    this.setState({ isShowAlreadyGotCoupon: showStatus });
  },
  getOmitDishGuidStepNumber() {
    const { shopInfo = {} } = this.props.dishMenuReducer;
    const { serviceSupply } = shopInfo;
    if (!serviceSupply || !serviceSupply.length) {
      return 3; // tips_3
    }
    return 0;
  },
  formatShowPrice(orderedDishes) {
    const { discountProps } = this.props;
    const isMember = discountProps && discountProps.isMember;
    const totalPrice = helper.getDishesPrice(orderedDishes);
    const totalMemberPrice = helper.getDishesPrice(orderedDishes, null, true);
    const allowShowMemberPrice = totalPrice > totalMemberPrice && totalMemberPrice >= 0 && isMember; // 是否满足展示条件
    let tpPartStyle = {};
    let tmpPartStyle = {};
    let tmpPart = '';

    if (allowShowMemberPrice) {
      tmpPartStyle = { marginRight: 4 };
      tpPartStyle = {
        textDecoration: 'line-through',
        color: '#999',
        fontSize: 11,
      };
      tmpPart = (
        <span className="price" style={tmpPartStyle}>
          <strong>{totalMemberPrice}</strong>
        </span>
      );
    }
    const tpPart = (
      <span className="price" style={tpPartStyle}>
        <strong>{totalPrice}</strong>
      </span>
    );
    return (
      <div className="o-flex shortcut-car-text__inner">
        {tmpPart}
        {tpPart}
      </div>
    );
  },
  renderOpenDialog(shopInfo = {}, isAcceptOrder, openShopTime) {
    const { isShowOpenStatus } = this.state;
    const { isEnableShop, openStatus, enableWeixinMini } = shopInfo;
    let closeWord = '';
    let enableCloseDialog = true;
    if (!enableWeixinMini && !!isWeiXinMiniBrowser) {
      closeWord = <div className="shopopen-time">{formatMessage(containnerText1.DishMenuApplicationmircAppUnOpen)}</div>;
      enableCloseDialog = false;
    } else if (!isEnableShop) {
      closeWord = (
        <div className="shopopen-time">
          <FormattedMessage {...shopMessages.isDisable} />
        </div>
      );
    } else if (!isAcceptOrder) {
      closeWord = (
        <div className="shopopen-time">
          <FormattedMessage {...shopMessages.isNotAcceptOrder} />
        </div>
      );
    } else if (!openStatus) {
      closeWord = (
        <div className="shopopen-time">
          <FormattedMessage {...shopMessages.openhour} />：{openShopTime || <FormattedMessage {...shopMessages.notConfig} />}
        </div>
      );
    }

    return (
      <div className="dish-mesthead-opendialog">
        {(!isEnableShop || !isAcceptOrder || !openStatus || (!enableWeixinMini && !!isWeiXinMiniBrowser)) && isShowOpenStatus && (
          <MessageDialog
            onConfirm={() => {
              if (!enableCloseDialog) return;
              this.setState({ isShowOpenStatus: false });
            }}
            btnText={<span className={!enableCloseDialog ? 'shopopen-btn_disabled' : ''}>{formatMessage(buttonMessages.iknown)}</span>}
          >
            <img className="shopopen-img" src={shopCloseImg} alt={formatMessage(shopMessages.closedFlag)} />
            <p className="shopopen-info">
              <FormattedMessage {...shopMessages.isClose} />
            </p>
            {closeWord}
          </MessageDialog>
        )}
      </div>
    );
  },
  handleGoPrepaidCode() {
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `${config.prepaidCodeUrl}?shopId=${shopId}&returnUrl=${returnUrl}`;
  },
  render() {
    // states
    const {
      callAble,
      callMsg,
      serviceStatus,
      notices,
      userInfo,
      toastProps,
      userOrderedDishList,
      tableAreaInfo,
      isDataInitOver,
      saveOrderChangeItem,
      shopMinConsume,
      selfChooseDishList,
    } = this.props.dishMenuZcReducer;

    const {
      activeDishTypeId,
      activeDishTypeIdIndex,
      dishTypesData,
      dishDetailData,
      dishDescData,
      errorMessage,
      openTimeList,
      shopInfo = {},
      shopLogo,
      dishesDataDuplicate,
      load,
      orderPageImage,
      tsOperateImgUrl,
      tsOperateUrl,
      swiperAdImgs = [],
      // tsCartImageUrl,
      fullAdvertImgUrl,
      fullAdvertUrl,
      showFullscreenAd,
      isAcceptOrder,
      dishDetailRecommendDishList,
      soldTopDishList,
    } = this.props.dishMenuReducer;
    // actions
    const {
      activeDishType,
      toggleDishDetailPopup,
      toggleDishDescPopup,
      clearErrorMsg,
      callBell,
      clearBell,
      showErrMsgFunc,
      getMarketCoupons,
      cancelCallMsg,
      updateCanCall,
      reinstateUndefined,
    } = this.props;
    const {
      isChildrenShow,
      loadingInfo,
      isShowSearch,
      allDiscount,
      showDishCouponSuccess,
      showFixedCoupon,
      isSync,
      showCouponList,
      isShowAlreadyGotCoupon,
      dishIdForStatistics,
      flodUpAppendCss,
      autoAddedMustOrderDishes,
      showSelfChoose,
      isShowLoginExceptionDialog,
      showLoginExceptionDesc,
    } = this.state;
    const marketList = shopInfo.marketList;
    const marketListUpdate = shopInfo.marketListUpdate;
    const { enableMemberRegistry, discountProps, pageIsLoaded, guide, menuDataStatus } = this.props.dishMenuReducer;
    const isMember = discountProps && discountProps.isMember;
    const orderedDishes = this.getCurrentOrderedDishes(userOrderedDishList, dishesDataDuplicate);
    const dishesCount = helper.getDishesCount(orderedDishes);
    const tableInfo = getTableInfoInSessionStorage(shopId);
    const dishPageTpl = this.props.dishMenuReducer.dishPageTpl || 'default';
    this.setTrunToDetailPage(serviceStatus);
    const scanShow =
      serviceStatus && !isSync && userInfo && !(tableInfo.tableId || tableInfo.tableKey || tableInfo.orderId) && (isWeiXinBrowser || isAlipayBrowser);
    /* const scanShow = true; */
    const changeShowData = helper.getOrderedDishes(dishesDataDuplicate);

    const changeShowDataItems = changeShowData.reduce((changeItems, item) => {
      changeItems[item.id] = item;

      return changeItems;
    }, {});

    const openShopTimeStr = `${helper.formatOpenTime(openTimeList)}`;
    const openShopTime = openShopTimeStr ? (
      <div className="o-flex__fluid">
        <div>{helper.formatOpenTime(openTimeList)}</div>
      </div>
    ) : (
      ''
    );

    const openDialog = this.renderOpenDialog(shopInfo, isAcceptOrder, openShopTime);
    const isRegistry = (enableMemberRegistry && isMember === false) || false;

    let showReceiveCoupons = false;
    if (
      (!shopInfo.isOldMarketing && showCouponList && this.getReceiveCouponsStatus() && shopInfo.couponList.length !== 0) ||
      (shopInfo.isOldMarketing && showCouponList && this.getReceiveCouponsStatus() && shopInfo.marketCoupon && shopInfo.marketCoupon.coupId) ||
      isShowAlreadyGotCoupon
    ) {
      showReceiveCoupons = true;
    }
    const formatShowPrice = this.formatShowPrice(orderedDishes);
    const isPayFirst = shopInfo.diningForm === 2;
    const prepaidCodes = getPrepaidCodes(shopId);
    const showPrepaidCodeTip = isPayFirst && shopMinConsume && shopMinConsume.state === 1 && !prepaidCodes.length && !tableInfo.orderId;

    return !pageIsLoaded ? (
      <PreloadSkeleton />
    ) : (
      <div className="o-flex o-flex--column dish-menu-zc">
        {openDialog}
        {isRegistry && (
          <div className="register notice">
            <a href={`/member/register${location.search}&returnUrl=${encodeURIComponent(location.href)}`}>
              <FormattedMessage {...dishMenuMessages.registerGoToRegister} />
            </a>
            <p>
              <FormattedMessage {...dishMenuMessages.registerDescription} />～
            </p>
          </div>
        )}

        <div
          className={classnames('o-flex o-flex--column dish-menu-zc-main', {
            scanShow,
          })}
        >
          <DishMesthead
            shopInfo={shopInfo}
            shopLogo={shopLogo}
            tableInfo={tableAreaInfo}
            setSearchPage={this.setSearchPage}
            setAllDiscount={this.setAllDiscount}
            tsOperateImgUrl={tsOperateImgUrl}
            tsOperateUrl={tsOperateUrl}
            swiperAdImgs={swiperAdImgs}
            orderPageImage={orderPageImage}
            isAcceptOrder={isAcceptOrder}
            discountProps={discountProps}
            openShopTimeStr={openShopTimeStr}
            openShopTime={openShopTime}
            flodUpAppendCss={flodUpAppendCss}
            isShowHalf={false} // 正餐不显示第二杯半价的信息
          />
          <div ref="scrollWrap" className={`${dishPageTpl} scroller-wrap o-flex__fluid dish-menu-zc`} onTouchTap={this.onDishTouchTap}>
            <DishTypeScroller
              theme={dishPageTpl}
              dishTypesData={dishTypesData}
              dishesData={dishesDataDuplicate}
              activeDishTypeId={activeDishTypeId}
              activeDishTypeIdIndex={activeDishTypeIdIndex}
              onDishTypeElementTap={activeDishType}
              diningForm={shopInfo.diningForm}
            />
            <DishScroller
              isDataInitOver={isDataInitOver}
              saveOrderChangeItem={saveOrderChangeItem}
              theme={dishPageTpl}
              changeShowData={changeShowData}
              dishTypesData={dishTypesData}
              dishesData={dishesDataDuplicate}
              diningForm={shopInfo.diningForm}
              activeDishTypeId={activeDishTypeId}
              activeDishTypeIdIndex={activeDishTypeIdIndex}
              setSearchPage={this.setSearchPage}
              onScroll={activeDishType}
              marketList={marketList}
              reinstateUndefined={reinstateUndefined}
              onOrderBtnTap={this.handleOrderDishChange}
              onPropsBtnTap={dish => {
                if (!this.onShoppingCartRelativeBtnClick()) {
                  return;
                }

                toggleDishDetailPopup(dish);
              }}
              onImageBtnTap={dish => {
                this.setState({ dishIdForStatistics: -1 });
                toggleDishDescPopup(dish);
              }}
              marketListUpdate={marketListUpdate}
              shopInfo={shopInfo}
              load={load}
              getMarketCoupon={getMarketCoupons}
              onScrolling={direction => {
                this.setScrollTop(direction);
              }}
              showHotSpan={this.showHotSpans}
              soldTopDishList={this.getDishHotElement(soldTopDishList, dishesDataDuplicate)}
              couponType={'dishMenu'}
              showCouponsList={this.showCouponsList}
              showAlreadyGotCoupon={this.showAlreadyGotCoupon}
              isZc // 是否正餐
              hasAds={!!swiperAdImgs.length}
            />
          </div>
          {dishDetailData !== undefined ? (
            <DishDetailContainer
              changeShowDataItems={changeShowDataItems}
              dish={dishDetailData}
              sameRuleDishList={this.getSameRuleDishList(dishDetailData, dishesDataDuplicate)}
              onCloseBtnTap={toggleDishDetailPopup}
              onAddToCarBtnTap={this.onDishDetailAddBtnTap}
            />
          ) : (
            false
          )}
          {dishDescData !== undefined ? (
            <div onTouchTap={this.onDishTouchTap}>
              <DishDescPopup
                dish={dishDescData}
                onOrderBtnTap={this.handleOrderDishChange}
                onPropsBtnTap={dish => {
                  if (!this.onShoppingCartRelativeBtnClick()) {
                    return;
                  }

                  toggleDishDetailPopup(dish);
                }}
                urlType={helper.getUrlParam('type')}
                dishesDataDuplicate={dishesDataDuplicate}
                menuDataStatus={menuDataStatus}
                toggleDishDescPopup={toggleDishDescPopup}
                recommendDishList={dishDetailRecommendDishList}
                dishIdForStatistics={dishIdForStatistics}
                theme={dishPageTpl}
              />
            </div>
          ) : (
            false
          )}
          {errorMessage.text ? <Toast errorMessage={errorMessage.text} clearErrorMsg={clearErrorMsg} timeout={errorMessage.timeout} /> : false}
        </div>
        <div
          className={classnames('shortcut-operate', {
            'shortcut-operate-bottom': scanShow && !isShowSearch && !this.state.showHotSpan,
            'shortcut-operate--desc': !!dishDescData,
            'shortcut-operate-hidden': !isDataInitOver,
          })}
        >
          <ReactCSSTransitionGroup transitionName="must-order-dish-fade" transitionEnterTimeout={600} transitionLeaveTimeout={600}>
            {autoAddedMustOrderDishes && (
              <div className="auto-added-must-order-dishes-tip">
                <div className="content">
                  {autoAddedMustOrderDishes.map(dish => `${dish.count}${dish.unitName}${dish.name}`).join(', ')}
                  {formatMessage(dishMenuMessages.addedToCart)}
                </div>
              </div>
            )}
          </ReactCSSTransitionGroup>
          <div className={`btn-shortcut-outer ${this.state.dropInShoping ? 'dropin-shopcart-animation' : ''}`}>
            <div
              onTouchTap={evt => {
                if (!this.onShoppingCartRelativeBtnClick()) {
                  return;
                }
                this.jumpDetail(evt, dishesCount);
              }}
              className={classnames('btn-shortcut btn-shortcut-car btn-shortcut-larger bg-grey', {
                'shortcut-car-empty-padding': dishesCount === 0,
                'shortcut-car-left-margin': !dishDescData,
              })}
            >
              <span
                className={classnames('shortcut-car-text ellipsis', {
                  'shortcut-car-empty': dishesCount === 0,
                })}
              >
                {dishesCount > 0 ? formatShowPrice : formatMessage(dishMenuMessages.dishEmpty)}
              </span>
              {dishesCount > 0 && (
                <span
                  className={classnames('o-fz--11 shortcut-car--counter', {
                    'shortcut-car-count--modify': dishesCount > 99,
                  })}
                >
                  {dishesCount < 99 ? dishesCount : '99+'}
                </span>
              )}
              <span
                className={classnames('shortcut-car-chosenBtn o-btn--linear', {
                  'shortcut-car-chosenBtn-hidden': dishesCount === 0,
                })}
              >
                {formatMessage(cartMessages.closeOk)}
              </span>
            </div>
          </div>
          {serviceStatus && (
            <BtnShortcutMulti
              isChildrenShowProp={isChildrenShow}
              orderId={serviceStatus.orderId}
              btnAttributesMulti={{
                btnAttributesDefault: {
                  size: 'default',
                  classnames: 'o-btn--default',
                },
                btnAttributesMain: {
                  onClick: this.hanleMainClick,
                  text: formatMessage(cartMessages.func),
                  iconWidth: '11px',
                  verticalAlign: '-1px',
                },
                btnDisable: this.getBtnDisable(serviceStatus),
              }}
              shopMinConsume={shopMinConsume}
              isNavi
              bell={
                <QuickMenu
                  callBell={callBell}
                  clearBell={clearBell}
                  callMsg={callMsg}
                  callAble={callAble}
                  dishes={dishesDataDuplicate}
                  serviceStatus={serviceStatus}
                  openTimeList={openTimeList}
                  showErrMsgFunc={showErrMsgFunc}
                  cancelCallMsg={cancelCallMsg}
                  updateCanCall={updateCanCall}
                  tableInfo={tableInfo}
                  shopInfo={shopInfo}
                  isFucBell
                />
              }
            />
          )}
          <div className="shortcut-car-animation of">
            <div className="real-animation" style={{ bottom: this.state.animationBottom }} ref="noticeWrap">
              {notices
                .map((item = {}, index) => (
                  <div className="shortcut-car-outer">
                    <div className="shortcut-car-item of" key={index} style={{ display: item.readed ? 'none' : '' }}>
                      <HttpsProtocolImage src={item.userPicPath || defaultPic} className="user-icon fl" alt={formatMessage(cartMessages.customerImg)} />
                      <span className="fr">{item.orderAction}</span>
                      <span className="ellipsis user-dishname">{item.dishName}</span>
                    </div>
                  </div>
                ))
                .asMutable()
                .reverse()}
            </div>
          </div>
          {false && (
            <QuickMenu
              callBell={callBell}
              clearBell={clearBell}
              callMsg={callMsg}
              callAble={callAble}
              dishes={dishesDataDuplicate}
              serviceStatus={serviceStatus}
              openTimeList={openTimeList}
              showErrMsgFunc={showErrMsgFunc}
              cancelCallMsg={cancelCallMsg}
              updateCanCall={updateCanCall}
              tableInfo={tableInfo}
              shopInfo={shopInfo}
            />
          )}
        </div>
        {scanShow && (
          <div className="o-flex qrcode-tip" onTouchTap={this.scanCode}>
            <div className="o-flex o-flex__fluid">
              <img src={ordertogether} className="qrcode-tip__together" alt="一起点餐" />
              <img src={combinedword} className="qrcode-tip__combinedword" alt="一起点餐" />
            </div>
            <div className="o-flex o-flex__fixed qrcode-tip__word">
              <div className="depart-line" />
              <img src={joinword} className="qrcode-tip__wordimg" alt="一起点餐" />
            </div>
          </div>
        )}
        {toastProps && <SyncOrderToast toastProps={toastProps} onCloseWindow={this.closeWindow} />}
        {loadingInfo && loadingInfo.ing && <Loading word={loadingInfo.text} />}
        {isShowSearch && (
          <SearchDish
            dishesData={dishesDataDuplicate}
            dishTypesData={dishTypesData}
            diningForm={shopInfo.diningForm}
            marketList={marketList}
            isMember={isMember}
            onOrderBtnTap={this.handleOrderDishChange}
            scanShow={scanShow}
            onPropsBtnTap={dish => {
              if (!this.onShoppingCartRelativeBtnClick()) {
                return;
              }

              toggleDishDetailPopup(dish);
            }}
            onImageBtnTap={toggleDishDescPopup}
            setSearchPage={this.setSearchPage}
          />
        )}
        {allDiscount && <div className="ads-column add-content">{allDiscount}</div>}
        {localStorage.getItem('shop_' + shopId + helper.getUrlParam('type')) === null &&
        helper.getUrlParam('type') === 'TS' &&
        guide &&
        this.props.dishMenuZcReducer.guidStatus ? (
          <DishGuid dishType={{ type: 'TS', showScan: scanShow }} omitDishGuidStepNumber={this.getOmitDishGuidStepNumber()} />
        ) : (
          ''
        )}
        {((shopInfo.couponSuccessInfo && shopInfo.couponSuccessInfo.couponId && showDishCouponSuccess) || shopInfo.couponSuccess) && (
          <DishCouponSuccess shopInfo={shopInfo} closeDishCouponSuccess={this.closeDishCouponSuccess} showFixedCoupon={showFixedCoupon} />
        )}
        {showReceiveCoupons && (
          <ReceiveCoupons
            handleClose={this.hiddenCouponsList}
            ruleId={shopInfo.ruleId || 0}
            couponList={shopInfo.couponList}
            getCoupons={this.props.getMarketCoupons}
            getCoupontoGuid={this.props.getCoupontoGuid}
            isShowAlreadyGotCoupon={isShowAlreadyGotCoupon}
            shopInfo={shopInfo}
            couponType={1}
            title={
              isShowAlreadyGotCoupon
                ? formatMessage(containnerText1.DishMenuApplicationgetSpecialGift)
                : formatMessage(containnerText1.DishMenuApplicationgetSpecialGiftSuccess)
            }
          />
        )}
        {this.state.showHotSpan && (
          <div onTouchTap={this.onDishTouchTap}>
            <DishHotSlide
              goBack={this.cancelHotSpan}
              theme={dishPageTpl}
              dishesData={dishesDataDuplicate}
              diningForm={shopInfo.diningForm}
              marketList={marketList}
              onOrderBtnTap={this.handleOrderDishChange}
              onPropsBtnTap={dish => {
                if (!this.onShoppingCartRelativeBtnClick()) {
                  return;
                }

                toggleDishDetailPopup(dish);
              }}
              onImageBtnTap={toggleDishDescPopup}
              soldTopDishList={this.getDishHotElement(soldTopDishList, dishesDataDuplicate)}
            />
          </div>
        )}
        {showFullscreenAd && <FullscreenAd imageUrl={fullAdvertImgUrl} link={fullAdvertUrl} />}
        {isShowLoginExceptionDialog && (
          <div className="login-exception-tip">
            <div className="login-exception-container">
              <div className="login-exception-text">系统异常</div>
              <div className="login-exception-desc">{showLoginExceptionDesc}</div>
            </div>
          </div>
        )}
        <div id="handleInputDOM" data-editable={shopInfo.goodsNumEditable} style={{ display: 'none' }} />
        {showPrepaidCodeTip && (
          <div className="check-prepaid-code-tip">
            <div className="check-prepaid-code-container">
              <div className="check-prepaid-code-img" />
              <div className="check-prepaid-code-tip-text">请先验证预付单</div>
              <button className="o-btn o-btn--linear" onTouchTap={this.handleGoPrepaidCode}>
                立即验证
              </button>
            </div>
          </div>
        )}
        <HealthIcon />
        {showSelfChoose && (
          <SelfChooseMustOrder
            selfChooseDishList={selfChooseDishList}
            orderedDishes={orderedDishes}
            onOrderBtnTap={this.handleOrderDishChange}
            onConfirm={this.handleConfirmSelfChoose}
            onPropsBtnTap={dish => {
              if (!this.onShoppingCartRelativeBtnClick()) {
                return;
              }

              toggleDishDetailPopup(dish);
            }}
          />
        )}
      </div>
    );
  },
});

const mapActionsToProps = dispatch => {
  const mergedActions = Object.assign({}, actions, commonActions);
  return { ...bindActionCreators(mergedActions, dispatch), dispatch };
};

module.exports = connect(
  state => state,
  mapActionsToProps,
)(DishMenuZcApplication);



// WEBPACK FOOTER //
// ./src/container/dish-menu-zc/application.jsx